import _ from 'lodash';
import {persurlToStringFormat} from 'model/PersurlUtil';
import {confirmJN} from 'module/ConfirmDialog/component/ConfirmDialogContainer';
import {Booking, Persurl} from 'generated/JavaTOmodifications'
import {SisName} from 'util/SisName'
import {ValidationOptions} from 'module/edesc/validation/EntryDescriptionValidation'
import {CFModel} from 'module/CustomField/type/CFType'
import {BSModelIDPart} from 'module/BSCollection/type/BSCollectionStateType'
import {BSApiAction} from 'module/BSEntry/util/BSApiAction'
import {isEqualCFModel} from 'module/EventDialog/util/isEqualCFModel'
import {BSAPIModelType} from 'module/BSEntry/BSRestAPI'
import {WorkflowChangeableFields} from 'module/BSEntry/EntryTypeParams'

type DeprecatedModel = { getSisName: () => SisName }

export function showDeleteConfirm(model: CFModel | DeprecatedModel, additionalInfo?: string, options?: ValidationOptions) {
	if (options?.doNotInteract) return Promise.resolve()
	let message;
	switch ((model as CFModel).sisName || (model as DeprecatedModel).getSisName?.()) {
		case SisName.Booking:
			message = "Möchten Sie die Buchung wirklich löschen? ";
			break;
		case SisName.Persurl:
			message = 'Möchten Sie die ganztägige Abwesenheit wirklich löschen? ';
			break;
		default:
			message = 'Möchten Sie den Eintrag wirklich löschen? ';
			break;
	}
	if (typeof additionalInfo == 'string') message += additionalInfo;
	return confirmJN("Löschen", message)
}

// predefined error messages
/**
 *
 * @param arrayOfModels array of objects, that have the method toStringFormat for serialisation
 * @returns {$.Deferred}
 */
export function showPersurlCollisionMessage(arrayOfModels?: Persurl[]) {
	//todo skip on options.doNotInteract? may have changed after a while...
	let msg = "Bei dieser Aktion werden existierende ganztägige Abwesenheiten überschrieben";
	if (!arrayOfModels || !arrayOfModels.length) msg += ".";
	else {
		msg += ":\n";
		msg += _.map(arrayOfModels, m => persurlToStringFormat(m)).join('\n');
	}
	return confirmJN("Überschneidung", msg);
}

export function confirmOtherChangesIgnored(model: Partial<Booking | Persurl> | undefined, persistedModel: BSModelIDPart | Booking | Persurl | undefined, options: ValidationOptions, abltextPlain?: string) {
	if (options.apiAction && !options.doNotInteract && persistedModel && (persistedModel.sisName === SisName.Persurl || persistedModel.sisName === SisName.Booking)) {
		let txtOnlyAction = null;
		switch (options.apiAction) {
			case BSApiAction.DELETE:
				txtOnlyAction = 'Löschen';
				break;
			case BSApiAction.ABL:
				txtOnlyAction = abltextPlain;
				break;
		}
		if (txtOnlyAction && !isEqualCFModel(_.omit(model, WorkflowChangeableFields), _.omit(persistedModel as BSAPIModelType, WorkflowChangeableFields))) {
			// only ask if action was user-initiated (not only changed in form)
			return confirmJN(
				`Änderung beim ${txtOnlyAction}`,
				`Beim ${txtOnlyAction} wird nur die Bemerkung gesichert. Andere Änderungen werden ignoriert. Soll die Aktion ohne diese Änderungen durchgeführt werden?`,
			).then(() => [undefined])
		}
	}
	return Promise.resolve([undefined]);
}